export const SimpleInput = ({
	id,
	type,
	label,
	isRequired,
	limit,
	value,
	onChange,
	labelClass,
	fieldClass,
	isValid,
	errorMessage,
}) => {
	return (
		<>
			<label htmlFor={id} className={labelClass}>
				<p>
					{label}
					{isRequired ? <span>*</span> : null}
				</p>
			</label>
			<div className={"relative"}>
				<input
					type={type}
					id={id}
					name={id}
					value={value}
					onChange={onChange}
					maxLength={limit}
					className={
						"focus:ring-none focus:ring-none block w-full appearance-none border-0 border-b px-0 pb-0 pt-1.5 focus:outline-none focus:ring-0 " +
						fieldClass +
						(isValid ? " border-[#a8a8a8]" : " border-[#ff4750]")
					}
				/>
			</div>
			<p
				className={
					(isValid ? "text-transparent" : "text-[#A6A6A6]") + " text-[10px]"
				}
			>
				{errorMessage}
			</p>
		</>
	);
};
